module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pendenciasFiltradas), function(p) {
    return _c('a', {
      staticClass: "col-md-3 col-sm-6 hover-items",
      attrs: {
        "href": '/#/website/arrematantes/' + p.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "panel wrapper"
    }, [_c('div', {
      staticClass: "m-t-none font-bold"
    }, [_vm._v(_vm._s(p.apelido))]), _vm._v(" "), _c('div', {
      staticClass: "m-t-none"
    }, [_vm._v(_vm._s(p.pessoa.nome))]), _vm._v(" "), _c('div', {
      staticClass: "m-t-none"
    }, [_vm._v("Solicitado " + _vm._s(_vm.moment(p.solicitacaoAprovacaoData.date).format('LLL')))])])])
  }), 0), _vm._v(" "), (!_vm.pendencias || _vm.pendenciasFiltradas.length === 0) ? _c('div', [_vm._v("\n      Nenhuma interação necessária até o momento\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pendencias && _vm.pendencias.length > 0 && _vm.pendencias.length !== _vm.pendenciasFiltradas.length) ? _c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b-xs"
  }, [_vm._v("Você ocultou algumas pendencias por tê-las visualizado.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.pendenciasVisualizadas = []
      }
    }
  }, [_vm._v("Reativar pendencias ocultadas")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36658056","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/PainelAprovacao.vue
// module id = 750
// module chunks = 2